import type { components } from "@/api/schema";

import { formatPeriod } from "./format-period";

type Campaign = components["schemas"]["Campaign"];

const HEADER = ["Name", "Period", "Active", "Finished", "Draft", "Created By"] as const;

function escapeCsv(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/** Serialise the visible campaign rows to CSV (header + rows). */
export function campaignsToCsv(items: Campaign[]): string {
  const rows = items.map((c) =>
    [
      c.name,
      formatPeriod(c.period_start, c.period_end),
      c.status_rollup.active,
      c.status_rollup.finish,
      c.status_rollup.draft,
      c.created_by,
    ]
      .map(escapeCsv)
      .join(","),
  );
  return [HEADER.join(","), ...rows].join("\n");
}
